module.exports = __webpack_public_path__ + "img/sun-low.7d86901b.svg";